import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API, formatErr } from "@/lib/api";
import { LogoFull } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("spd_token", data.token);
      nav("/admin/devis");
    } catch (e2) {
      setErr(formatErr(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="grain relative flex min-h-screen items-center justify-center bg-ink px-5 text-paper">
      <form onSubmit={submit} className="relative w-full max-w-sm" data-testid="admin-login-form">
        <LogoFull light className="w-48" />
        <h1 className="mt-8 font-display text-5xl">Espace pro</h1>
        <p className="mt-2 text-sm text-paper/70">Consultez les demandes de devis.</p>
        <label className="mt-10 block">
          <span className="eyebrow text-paper/70">E-mail</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input"
            className="mt-2 w-full border-b border-paper/25 bg-transparent py-3 outline-none focus:border-gold" />
        </label>
        <label className="mt-6 block">
          <span className="eyebrow text-paper/70">Mot de passe</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input"
            className="mt-2 w-full border-b border-paper/25 bg-transparent py-3 outline-none focus:border-gold" />
        </label>
        {err && <p className="mt-5 text-sm text-red-300" data-testid="admin-login-error">{err}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit" className="mt-10 flex w-full items-center justify-center gap-2 bg-gold py-4 font-semibold text-ink transition-colors hover:bg-paper disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Se connecter
        </button>
      </form>
    </main>
  );
}
